import portalApi from "../api/apiSlice";

const quizMarkApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    getQuizMarks: builder.query({
      query: () => `quizMark`,
    }),

    getSingleQuizMark: builder.query({
      query: (data) =>
        `quizMark?student_id=${data.student_id}&video_id=${data.video_id}`,
    }),

    addQuizMark: builder.mutation({
      query: (quizMark) => ({
        url: "quizMark",
        method: "POST",
        body: quizMark,
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            portalApi.util.updateQueryData(
              "getSingleQuizMark",
              { student_id: arg.student_id, video_id: arg.video_id },
              (draft) => {
                draft.push(data);
              }
            )
          );

          dispatch(
            portalApi.util.updateQueryData(
              "getQuizMarks",
              undefined,
              (draft) => {
                draft.push(data);
              }
            )
          );
        } catch {}
      },
    }),
  }),
});

export const {
  useGetQuizMarksQuery,
  useAddQuizMarkMutation,
  useGetSingleQuizMarkQuery,
} = quizMarkApi;
